// For future peeps- WeekOfYear is the same as YearWeek (C#). Not sure how that terminology diverged.
export const SUNDAY = 0;
export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 3;
export const THURSDAY = 4;
export const FRIDAY = 5;
export const SATURDAY = 6;
const WEEK_MILLISECONDS = 604800000;
export var YearWeekType;
(function (YearWeekType) {
    YearWeekType[YearWeekType["Iso"] = 0] = "Iso";
    YearWeekType[YearWeekType["Aug28"] = 1] = "Aug28";
    YearWeekType[YearWeekType["Jan1"] = 2] = "Jan1";
})(YearWeekType || (YearWeekType = {}));
const YearWeekTypeStringMap = {
    Iso: YearWeekType.Iso,
    Aug28: YearWeekType.Aug28,
    Jan1: YearWeekType.Jan1,
};
export function getWeekOfYearFromTypeString(date, type, startDayOfWeek = MONDAY) {
    return getWeekOfYear(date, YearWeekTypeStringMap[type], startDayOfWeek);
}
export function getWeekOfYear(date, type, startDayOfWeek = MONDAY) {
    switch (type) {
        case YearWeekType.Iso:
            return IsoWeekOfYear.fromDate(date, startDayOfWeek);
        case YearWeekType.Aug28:
            return Aug28WeekOfYear.fromDate(date, startDayOfWeek);
        case YearWeekType.Jan1:
            return Jan1WeekOfYear.fromDate(date, startDayOfWeek);
        default:
            return IsoWeekOfYear.fromDate(date, startDayOfWeek);
    }
}
/**
 * Represents the ISO week number and year of a given date
 */
export class IsoWeekOfYear {
    get endDayOfWeek() {
        return ((this.startDayOfWeek + 6) % 7);
    }
    constructor(year, week, startDayOfWeek = MONDAY) {
        this.startDayOfWeek = startDayOfWeek;
        this.year = year;
        this.week = week;
    }
    static fromDate(date, startDayOfWeek = MONDAY) {
        const year = this.yearOf(date, startDayOfWeek);
        const week = this.weekOf(date, startDayOfWeek);
        return new this(year, week, startDayOfWeek);
    }
    /**
     * Gives the date of a provided weekday for this yearweek
     */
    dateOfWeekDay(weekday) {
        const date = this.week1Day1(this.year);
        // Generate a date that will be in the week
        date.setUTCDate(date.getUTCDate() + 7 * (this.week - 1));
        // Adjust the date to be for the day
        date.setUTCDate(date.getUTCDate() + weekday - date.getUTCDay());
        return date;
    }
    // Get the first day of this week
    startDate() {
        const wk1day1 = this.week1Day1(this.year);
        const diff_millis = (this.week - 1) * WEEK_MILLISECONDS;
        return new Date(wk1day1.getTime() + diff_millis);
    }
    // Get the last day of this week
    endDate() {
        const wk1day1 = this.week1Day1(this.year);
        const diff_millis = (this.week - 1) * WEEK_MILLISECONDS;
        return nextOrCurrentWeekday(new Date(wk1day1.getTime() + diff_millis), this.endDayOfWeek);
    }
    addWeeks(delta) {
        return new this.constructor(this.year, this.week + delta, this.startDayOfWeek).normalize();
    }
    nextWeek() {
        return this.addWeeks(1);
    }
    previousWeek() {
        return this.addWeeks(-1);
    }
    /**
     * Fix up the year and week if they are out of range
     */
    normalize() {
        while (this.week > this.weeksInYear(this.year))
            this.week -= this.weeksInYear(this.year++);
        while (this.week < 1)
            this.week += this.weeksInYear(--this.year);
        return this;
    }
    toString() {
        let wk = "0" + this.week;
        if (wk.length > 2)
            wk = wk.substring(1);
        return this.year + "-" + wk;
    }
    weeksInYear(year) {
        return this.constructor.weeksInYear(year, this.startDayOfWeek);
    }
    week1Day1(year) {
        return this.constructor.week1Day1(year, this.startDayOfWeek);
    }
    /**
     * Get the date of the first day of Week 1 this year
     */
    static week1Day1(year, startDayOfWeek) {
        // According to ISO, the year in which the thursday falls is the year of the week
        // So, find the first thursday of the year to find the first week
        // then, start the day on the preceeding startDayOfWeek
        let date = new Date(Date.UTC(year, 0, 1)); // First day of year
        date = nextOrCurrentWeekday(date, THURSDAY); // First Thursday
        date = previousOrCurrentWeekday(date, startDayOfWeek); // Then, roll back to the desired Start day of week
        return date;
    }
    /**
     * Return the number of weeks in a year for this WeekOfYear type
     */
    static weeksInYear(year, startDayOfWeek = MONDAY) {
        const wkyr = new this(year, 53, startDayOfWeek);
        const valid = this.constructor.yearOf(wkyr.endDate()) ==
            year;
        return valid ? 53 : 52;
    }
    static yearOf(date, startDayOfWeek = MONDAY) {
        // ISO 8601: the year of this week is the year of this week's Thursday
        const startOfThisWeek = previousOrCurrentWeekday(date, startDayOfWeek);
        const thisThursday = nextOrCurrentWeekday(startOfThisWeek, THURSDAY);
        return thisThursday.getUTCFullYear();
    }
    static weekOf(date, startDayOfWeek = MONDAY) {
        const day1wk1 = this.week1Day1(this.yearOf(date, startDayOfWeek), startDayOfWeek);
        return Math.floor(1 + (date.getTime() - day1wk1.getTime()) / WEEK_MILLISECONDS);
    }
}
export class Aug28WeekOfYear extends IsoWeekOfYear {
    static yearOf(date, startDayOfWeek = MONDAY) {
        const endOfWeek = nextOrCurrentWeekday(date, ((startDayOfWeek + 6) % 7));
        if (endOfWeek.getUTCMonth() + 1 < 8)
            return endOfWeek.getUTCFullYear();
        if (endOfWeek.getUTCMonth() + 1 > 8)
            return endOfWeek.getUTCFullYear() + 1;
        if (endOfWeek.getUTCDate() < 28)
            return endOfWeek.getUTCFullYear();
        else
            return endOfWeek.getUTCFullYear() + 1;
    }
    static week1Day1(year, startDayOfWeek = MONDAY) {
        let date = new Date(Date.UTC(year - 1, 7, 28));
        date = previousOrCurrentWeekday(date, startDayOfWeek);
        return date;
    }
}
export class Jan1WeekOfYear extends IsoWeekOfYear {
    static yearOf(date, startDayOfWeek) {
        const endOfWeek = nextOrCurrentWeekday(date, ((startDayOfWeek + 6) % 7));
        return endOfWeek.getUTCFullYear();
    }
    static week1Day1(year, startDayOfWeek = MONDAY) {
        let date = new Date(Date.UTC(year, 0, 1));
        date = previousOrCurrentWeekday(date, startDayOfWeek);
        return date;
    }
}
// Get the date of the next DayOfWeek, or this date if it is already that day
function nextOrCurrentWeekday(date, dayOfWeek) {
    const daysUntil = (dayOfWeek - date.getUTCDay() + 7) % 7;
    date.setUTCDate(date.getUTCDate() + daysUntil);
    return date;
}
// Get the date of the previous DayOfWeek, or this date if it is already that day
function previousOrCurrentWeekday(date, dayOfWeek) {
    const daysFrom = (date.getUTCDay() - dayOfWeek + 7) % 7;
    date.setUTCDate(date.getUTCDate() - daysFrom);
    return date;
}
